import { useEffect } from "react";

function isIOSAppLike() {
  const ua = window.navigator.userAgent || "";
  const iOS = /iPhone|iPad|iPod/i.test(ua);

  return iOS;
}

function isEditableTarget(el) {
  if (!el || !(el instanceof HTMLElement)) return false;

  const tag = el.tagName?.toLowerCase();
  if (tag === "textarea" || tag === "select") return true;

  if (tag === "input") {
    const type = (el.getAttribute("type") || "text").toLowerCase();
    return ![
      "checkbox",
      "radio",
      "range",
      "file",
      "color",
      "button",
      "submit",
      "reset",
    ].includes(type);
  }

  return el.isContentEditable;
}

export default function usePreventIOSInputZoom() {
  useEffect(() => {
    if (!isIOSAppLike()) return;

    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;

    const originalContent =
      viewport.getAttribute("content") ||
      "width=device-width, initial-scale=1, viewport-fit=cover";

    let restoreTimer = null;

    const lockedContent =
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover";

    const restoreViewport = () => {
      if (restoreTimer) window.clearTimeout(restoreTimer);
      restoreTimer = window.setTimeout(() => {
        viewport.setAttribute("content", originalContent);
      }, 180);
    };

    const lockViewport = () => {
      if (restoreTimer) window.clearTimeout(restoreTimer);
      viewport.setAttribute("content", lockedContent);
    };

    const onFocusIn = (e) => {
      if (!isEditableTarget(e.target)) return;
      lockViewport();
    };

    const onFocusOut = (e) => {
      if (!isEditableTarget(e.target)) return;
      restoreViewport();
    };

    document.addEventListener("focusin", onFocusIn, true);
    document.addEventListener("focusout", onFocusOut, true);

    return () => {
      document.removeEventListener("focusin", onFocusIn, true);
      document.removeEventListener("focusout", onFocusOut, true);
      if (restoreTimer) window.clearTimeout(restoreTimer);
      viewport.setAttribute("content", originalContent);
    };
  }, []);
}
